// Adapted from: https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API

export default class VisibilityUtil {
    constructor(visibleCallback, hiddenCallback) {
        if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
            this.hiddenProp = "hidden";
            this.visibilityChangeEvent = "visibilitychange";
        }
        else if (typeof document.msHidden !== "undefined") {
            this.hiddenProp = "msHidden";
            this.visibilityChangeEvent = "msvisibilitychange";
        }
        else if (typeof document.webkitHidden !== "undefined") {
            this.hiddenProp = "webkitHidden";
            this.visibilityChangeEvent = "webkitvisibilitychange";
        }

        if (typeof document.addEventListener === 'undefined' || typeof document[this.hiddenProp] === 'undefined') {
            console.warn('VisibilityUtil: Browser does not support the Page Visibility API.');
            return;
        }

        this._handleChangeWithCallbacks = this.handleVisibilityChange.bind(this, visibleCallback, hiddenCallback);
        document.addEventListener(this.visibilityChangeEvent, this._handleChangeWithCallbacks, false);
    }

    handleVisibilityChange(visibleCallback, hiddenCallback) {
        if (document[this.hiddenProp]) {
            if (typeof hiddenCallback === 'function') hiddenCallback();
        }
        else {
            if (typeof visibleCallback === 'function') visibleCallback();
        }
    }

    removeListener() {
        if (!this.visibilityChangeEvent) {
            return;
        }

        document.removeEventListener(this.visibilityChangeEvent, this._handleChangeWithCallbacks, false);
    }
}